import React, { useRef, useEffect } from "react";
import { Spin, Button } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import { useInView } from "react-intersection-observer";

import { useAddNewMemo } from "../api/memo";
import { getToken } from "services/token-service/token.service";
import { useGetInfiniteMemo } from "services/hooks/useGetInfiniteMemo";

const schema = yup.object().shape({
  body: yup.string().required("Current Password is required!"),
});

const MemoComponent = (props) => {
  const { id, type, infoTabHeight } = props;
  const saveProfileMemoRef = useRef();
  const token = getToken();
  const { ref, inView } = useInView();

  const {
    register,
    handleSubmit,
    reset,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    data: memoData,
    isFetching: loadingMemos,
    refetch: userRefetch,
    fetchNextPage: userFetchNextPage,
    hasNextPage: userNextPage,
    isFetchingNextPage: userIsFetchingNextPage,
  } = useGetInfiniteMemo(type === "user" ? id : "");
  const {
    data: memoProfileData,
    isFetching: loadingProfileMemos,
    refetch: profileRefetch,
    fetchNextPage: profileFetchNextPage,
    hasNextPage: profileNextPage,
    isFetchingNextPage: profileIsFetchingNextPage,
  } = useGetInfiniteMemo(type === "profile" ? id : "");
  const { mutate: addNewMemo } = useAddNewMemo();

  const renderNotes = () => {
    return (
      <div className="MemosContainer">
        {type === "user" && memoData
          ? memoData[0]?.data.length > 0
            ? memoData.map((data) => {
                return data.data.map((commentDat) => {
                  return (
                    <div className="MemoContainer" key={commentDat.id}>
                      <div className="CommenterInfo">
                        <div className="CommenterName">
                          {commentDat.commenter.username}
                        </div>
                        <div className="CommenterTime">
                          {moment(commentDat.created_at).format(
                            "MM-D-YYYY, HH:mm"
                          )}
                        </div>
                      </div>
                      <div className="MemoBody">{commentDat.body}</div>
                    </div>
                  );
                });
              })
            : "No memos"
          : memoProfileData && memoProfileData[0]?.data.length > 0
          ? memoProfileData.map((data) => {
              return data.data.map((commentDat) => {
                return (
                  <div className="MemoContainer" key={commentDat.id}>
                    <div className="CommenterInfo">
                      <div className="CommenterName">
                        {commentDat.commenter.username}
                      </div>
                      <div className="CommenterTime">
                        {moment(commentDat.created_at).format(
                          "MM-D-YYYY, HH:mm"
                        )}
                      </div>
                    </div>
                    <div className="MemoBody">{commentDat.body}</div>
                  </div>
                );
              });
            })
          : "No memos"}

        {type === "user" ? (
          <div ref={ref}>
            {" "}
            {userIsFetchingNextPage
              ? "Loading more..."
              : userNextPage
              ? "Load More"
              : "Nothing more to load"}
          </div>
        ) : (
          <div ref={ref}>
            {" "}
            {profileIsFetchingNextPage
              ? "Loading more..."
              : profileNextPage
              ? "Load More"
              : "Nothing more to load"}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (inView) {
      type === "user" ? userFetchNextPage() : profileFetchNextPage();
    }
  }, [inView, userFetchNextPage, profileFetchNextPage, type]);

  const onSubmit = (data) => {
    addNewMemo(
      { data, profileID: id, token },
      {
        onSuccess: () => {
          reset();
          type === "user" ? userRefetch() : profileRefetch();
        },
      }
    );
  };

  return (
    <div className="MemoTab" style={{ height: infoTabHeight }}>
      {(type === "user" && loadingMemos && !memoData) ||
      (type === "profile" && loadingProfileMemos && !memoProfileData) ? (
        <Spin />
      ) : (
        renderNotes()
      )}
      <div className="InputContainer">
        <form onSubmit={handleSubmit(onSubmit)}>
          <textarea
            name="body"
            placeholder="Enter new memo"
            {...register("body")}
          />
          <div className="ButtonContainer">
            <input type="submit" ref={saveProfileMemoRef} hidden />
            <Button
              className="SaveMemo"
              type="submit"
              onClick={() => {
                saveProfileMemoRef.current.click();
              }}
              loading={false}
            >
              {" "}
              Save{" "}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MemoComponent;
